import React from "react";

const AppContext = React.createContext({});
const EditorContext = React.createContext({});

export { AppContext, EditorContext };
